export const TEST_IDS = {
  clientsHeading: 'clients-heading',
  addClientButton: 'add-client-button',
  openSearch: 'open-search',
  searchInput: 'search-input',
  addTemplateButton: 'add-template',
  clientNameInput: 'client-name-input',
  passAddModalNameInput: 'pass-add-modal-name-input',
  passEditModalNameInput: 'pass-edit-modal-name-input',
  passStartDateInput: 'pass-start-date-input',
  passEndDateInput: 'pass-end-date-input',
  passTypeNameInput: 'pass-type-name-input',
  durationEditorTrigger: 'duration-editor-trigger',
  durationNumberInput: 'duration-number',
  creditsEditorTrigger: 'credits-editor-trigger',
  creditsInput: 'credits',
  passRemainingCreditsInput: 'pass-remaining-credits',
  passTotalCreditsInput: 'pass-total-credits',
  saveTemplateButton: 'save-button',
  deleteTemplateButton: 'delete-button',
  deleteTemplateConfirmButton: 'delete-template-confirm',
  markVisitButton: 'mark-visit-button',
  profileClientButton: 'profile-client-button',
  addPassButton: 'add-pass-button',
  updateClientNameButton: 'update-or-save-client-name',
  activePassesGroup: 'active-passes-group',
  futurePassesSection: 'future-passes-section',
  passesEmptyState: 'passes-empty-state',
  savePassButton: 'save-pass-button',
  deletePassButton: 'delete-pass-button',
  deletePassConfirmButton: 'delete-pass-confirm',
  updatePassButton: 'update-pass-button',
  sortChip: 'sort-chip',
  sortSheet: 'sort-sheet',
  clientsCount: 'clients-count',
  filterChips: 'filter-chips',
  passUnlimitedDurationToggle: 'pass-unlimited-duration-toggle',
  passUnlimitedCreditsToggle: 'pass-unlimited-credits-toggle',
  passModalCancelButton: 'pass-modal-cancel-button',
  passDateStartPill: 'pass-date-start-pill',
  passDateEndPill: 'pass-date-end-pill',
  passCalendarShell: 'pass-calendar-shell',
  passCalendarMonthLabel: 'pass-calendar-month-label',
  passCalendarPrevMonth: 'pass-calendar-prev-month',
  passCalendarNextMonth: 'pass-calendar-next-month',
  passCreditsStepperDecrement: 'pass-credits-stepper-decrement',
  passCreditsStepperIncrement: 'pass-credits-stepper-increment',
  // Client header
  clientOptionsTrigger: 'client-options-trigger',
  clientAvatar: 'client-avatar',
  renameClientMenuItem: 'rename-client-menu-item',
  deleteClientMenuItem: 'delete-client-menu-item',
  // Passes section
  passesSectionHeader: 'passes-section-header',
  passesSectionAddButton: 'passes-section-add-button',
  pastPassesLink: 'past-passes-link',
  historySectionHeader: 'history-section-header',
  historySectionSearchButton: 'history-section-search-button',
  historyViewAllLink: 'history-view-all-link',
  // Past passes page
  pastPassesPageTitle: 'past-passes-page-title',
  pastPassesPageEmpty: 'past-passes-page-empty',
  // History page
  historyPageTitle: 'history-page-title',
  historyPageEmpty: 'history-page-empty',
  // Subscription
  subscriptionBanner: 'subscription-banner',
  subscriptionSubscribeButton: 'subscription-subscribe-button',
  // Profile page
  profileButton: 'profile-button',
  profileSubscriptionSection: 'profile-subscription-section',
  profileSubscribeButton: 'profile-subscribe-button',
  profileSupportLink: 'profile-support-link',
} as const;

export const TEST_ID_BUILDERS = {
  clientItem: (name: string) => `client-item-${name}`,
  passByName: (name: string) => name,
  passTemplateOption: (name: string) => name,
  passCalendarDay: (isoDate: string) => `pass-calendar-day-${isoDate}`,
  durationMeasureChip: (measure: string) => `duration-measure-${measure}`,
} as const;

export const TEST_ID_PATTERNS = {
  clientItemPrefix: /^client-item-/,
} as const;

export type TestId = (typeof TEST_IDS)[keyof typeof TEST_IDS];
